import * as C from '../../constants';
import defaultState from './defaultState';

export default {
  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_CLEAR](state) {
    Object.assign(state, defaultState());
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_FILTER_LOAD_PENDING](state) {
    state.filter.data = {
      ...state.filter.data,
      loading: true,
      error: false,
      selectedProductTypes: [],
      selectedBrands: [],
      selectedDomains: [],
      selectedSuppliers: [],
      productTypes: [],
      brands: [],
      domains: [],
      suppliers: [],
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_LOAD_SUCCESS](state, payload) {
    state.filter.data = {
      ...state.filter.data,
      loading: false,
      error: false,
      ...payload,
    };
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_FILTER_LOAD_FAILURE](state) {
    state.filter.data = {
      ...state.filter.data,
      loading: false,
      error: true,
    };
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_LIST_LOAD_PENDING](state) {
    state.tableData = {
      loading: true,
      error: false,
      rows: [],
      stays: [],
    };
    state.filter.lastSearch = {
      performed: true,
      date: { ...state.filter.date },
      data: { ...state.filter.data },
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_LIST_LOAD_SUCCESS](state, payload) {
    state.tableData = {
      ...state.tableData,
      loading: false,
      loaded: true,
      rows: payload.suppliers,
      stays: payload.stays,
    };
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_LIST_LOAD_FAILURE](state) {
    state.tableData = {
      ...state.tableData,
      loading: false,
      error: true,
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_TYPE_CHANGE](state, payload) {
    state.filter.data = { ...state.filter.data, selectedTableType: payload };
    state.filter.lastSearch.performed = false;
    state.tableData = {
      ...state.tableData,
      loaded: false,
      rows: [],
      stays: [],
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_ARRIVAL_FROM_CHANGE](state, payload) {
    state.filter.date = { ...state.filter.date, arrivalFromDate: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE](state, payload) {
    state.filter.date = { ...state.filter.date, arrivalToDate: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_PAID_FROM_CHANGE](state, payload) {
    state.filter.date = { ...state.filter.date, paidDateFromDate: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_PAID_TO_CHANGE](state, payload) {
    state.filter.date = { ...state.filter.date, paidDateToDate: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_PRODUCTS_CHANGE](state, payload) {
    state.filter.data = { ...state.filter.data, selectedProductTypes: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_BRANDS_CHANGE](state, payload) {
    state.filter.data = { ...state.filter.data, selectedBrands: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_DOMAINS_CHANGE](state, payload) {
    state.filter.data = { ...state.filter.data, selectedDomains: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_SUPPLIERS_CHANGE](state, payload) {
    state.filter.data = { ...state.filter.data, selectedSuppliers: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_SUPPLIERS_SEARCH](state, payload) {
    state.filter.data = { ...state.filter.data, supplierSearch: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_FILTER_HIDE_ZERO_CHANGE](state, payload) {
    state.filter.data = { ...state.filter.data, hideZeroSuppliers: payload };
  },

  /**
   * The filters remembered from the last visit (supplier-payments-filter-storage).
   *
   * @param state
   * @param payload {{date: Object, data: Object}}
   */
  [C.SUPPLIER_PAYMENTS_FILTER_RESTORE](state, payload) {
    state.filter.date = { ...state.filter.date, ...payload.date };
    state.filter.data = { ...state.filter.data, ...payload.data };
  },

  /**
   * Back to the defaults: dates, list type and every selection, and an empty table.
   *
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_FILTER_RESET](state) {
    const defaults = defaultState();
    state.filter.date = defaults.filter.date;
    state.filter.data = {
      ...state.filter.data,
      selectedTableType: defaults.filter.data.selectedTableType,
      selectedProductTypes: [],
      selectedBrands: [],
      selectedDomains: [],
      selectedSuppliers: [],
      supplierSearch: undefined,
      hideZeroSuppliers: defaults.filter.data.hideZeroSuppliers,
    };
    state.filter.lastSearch = defaults.filter.lastSearch;
    state.tableData = defaults.tableData;
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_LIST_DOWNLOAD_PENDING](state) {
    state.download.list = {
      loading: true,
      error: false,
    };
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_LIST_DOWNLOAD_SUCCESS](state) {
    state.download.list = {
      loading: false,
      error: false,
    };
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_LIST_DOWNLOAD_FAILURE](state) {
    state.download.list = {
      loading: false,
      error: true,
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_PENDING](state, payload) {
    state.download.specifications = {
      loading: true,
      error: false,
      name: payload,
    };
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_SUCCESS](state) {
    state.download.specifications = {
      loading: false,
      error: false,
      name: undefined,
    };
  },

  /**
   * @param state
   */
  [C.SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_FAILURE](state) {
    state.download.specifications = {
      loading: false,
      error: true,
      name: undefined,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/payments/supplierPayments/mutations.js